module.exports = __webpack_public_path__ + "img/1726036172612-screenshot-1726036150019.png.d1031258.webp";